import { type ReactNode } from "react";
import { View } from "@aws-amplify/ui-react";
import MarketingNavModern from "./MarketingNavModern";
import Footer from "./FooterModern";
import "./MarketingLayout.css";

interface MarketingLayoutProps {
  children: ReactNode;
}

function MarketingLayout({ children }: MarketingLayoutProps) {
  return (
    <View>
      {/* Skip Links for Accessibility */}
      <div className="skip-links">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <a href="#pricing" className="skip-link">
          Skip to pricing
        </a>
        <a href="#footer" className="skip-link">
          Skip to footer
        </a>
      </div>

      {/* Marketing Header */}
      <MarketingNavModern />

      {/* Content */}
      <View
        id="main-content"
        minHeight="calc(100vh - 120px)"
        paddingTop="80px"
        tabIndex={-1}
      >
        {children}
      </View>

      {/* Footer */}
      <div id="footer">
        <Footer />
      </div>
    </View>
  );
}

export default MarketingLayout;
